/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_MicrosoftInputs */

const en_signin_microsoft = /** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Microsoft`)
};

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const ar_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const he_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const ur_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const es_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const fr_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const de_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const pt_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const hi_signin_microsoft = en_signin_microsoft;

/** @type {(inputs: Signin_MicrosoftInputs) => LocalizedString} */
const bn_signin_microsoft = en_signin_microsoft;

/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Signin_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_microsoft = /** @type {((inputs?: Signin_MicrosoftInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_MicrosoftInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_microsoft(inputs)
	if (locale === "he") return he_signin_microsoft(inputs)
	if (locale === "ur") return ur_signin_microsoft(inputs)
	if (locale === "es") return es_signin_microsoft(inputs)
	if (locale === "fr") return fr_signin_microsoft(inputs)
	if (locale === "de") return de_signin_microsoft(inputs)
	if (locale === "pt") return pt_signin_microsoft(inputs)
	if (locale === "hi") return hi_signin_microsoft(inputs)
	if (locale === "bn") return bn_signin_microsoft(inputs)
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});